














import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'VPicker',

  props: {
    original: String,
    result: String
  },

  setup() {
    const answered = ref(false)

    return {
      answered
    }
  }
})
